import styled from '@emotion/styled';
import { layout, palette, radius, shadow, spacing, transition, typography } from '../../../style-utils/theme';

type ErrProps = { hasError?: boolean };
const border = (p: ErrProps) => {
  return p.hasError ? palette.alert : palette.line;
};
const restShadow = (p: ErrProps) => {
  return p.hasError ? shadow.focusError : shadow.xs;
};
const focusBorder = (p: ErrProps) => {
  return p.hasError ? palette.alert : palette.iris;
};
const focusShadow = (p: ErrProps) => {
  return p.hasError ? shadow.focusError : shadow.focus;
};

export const Group = styled.fieldset`
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
`;

export const GroupLegend = styled.legend`
  margin-bottom: ${spacing.xs};
  padding: 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.sm}px;
  font-weight: ${typography.weight.medium};
  letter-spacing: ${typography.tracking.snug};
  color: ${palette.inkSoft};
`;

/* Day · Month · Year on one row from the smallest phone up: the month by name
   takes the most room, the day the least. */
export const Parts = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 4fr) minmax(0, 3fr);
  gap: ${spacing.xs};
`;

export const Part = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const PartLabel = styled.label`
  margin-bottom: ${spacing.half};
  font-family: ${typography.ui};
  font-size: ${typography.size.xs}px;
  color: ${palette.slate};
`;

const box = `
  width: 100%;
  min-width: 0;
  height: ${layout.fieldHeight};
  padding: 0 ${spacing.sm};
  border-radius: ${radius.xs};
  background: ${palette.surface};
  color: ${palette.ink};
  font-family: ${typography.ui};
  font-size: ${typography.size.base}px;
  letter-spacing: ${typography.tracking.snug};
  transition: ${transition.colors};
`;

export const PartInput = styled.input<ErrProps>`
  ${box};
  border: 1px solid ${border};
  box-shadow: ${restShadow};
  &::placeholder {
    color: ${palette.slateLight};
  }
  &:hover {
    border-color: ${palette.lineStrong};
  }
  &:focus {
    outline: none;
    border-color: ${focusBorder};
    box-shadow: ${focusShadow};
  }
`;

export const PartSelect = styled.select<ErrProps>`
  ${box};
  padding: 0 ${spacing.xs};
  border: 1px solid ${border};
  box-shadow: ${restShadow};
  cursor: pointer;
  &:hover {
    border-color: ${palette.lineStrong};
  }
  &:focus {
    outline: none;
    border-color: ${focusBorder};
    box-shadow: ${focusShadow};
  }
`;

export const Hint = styled.p`
  margin: ${spacing.half} 0 0;
  font-family: ${typography.ui};
  font-size: ${typography.size.xs}px;
  color: ${palette.slate};
`;
